import { apiGet } from './client'

export interface PlanStateBlob {
  fsm?: string
  position?: Record<string, unknown>
  last_tick_at?: string
  last_error?: string
  stats?: Record<string, unknown>
  [k: string]: unknown
}

export interface PlanStateResponse {
  plan_id: string
  name: string
  lifecycle: string
  account_alias: string
  plan_state: PlanStateBlob
}

export interface RunEvent {
  id: string
  run_id: string | null
  event_type: string
  from_state: string | null
  to_state: string | null
  payload: Record<string, unknown> | null
  created_at: string
}

export interface PlanEventsResponse {
  count: number
  events: RunEvent[]
}

export const getPlanState = (planId: string) => apiGet<PlanStateResponse>(`/plans/${planId}/state`)
export const getPlanEvents = (planId: string, limit = 50) =>
  apiGet<PlanEventsResponse>(`/plans/${planId}/events`, { params: { limit } })
